<style>
input:checked ~ .radio {
    color:white;
    background-color: #084772;
}
</style>
<template>
    <div class="pt-6">
        <!-- Start Filter section -->
            <div class="relative z-10 px-2 sm:flex items-center justify-center sm:inset-0 w-full lg:mr-20 mr-0 rounded-full">
                <ProFilter
                    :user="user"
                    :industries="industries"
                    :industry="industry"
                    :professions="professions"
                    :profession="profession"
                    :organization="organization"
                    :search_options="searchOptions"
                    :radius-choices="radiusChoices"
                    :withSubmit="withSubmit"
                    v-on:applyFilters="applyFilters"
                    v-on:sortPros="sortPros"
                />
            </div>
        <div class=" overflow-y: auto">
            <div
                class="flex flex-row mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-6 gap-8"
            >
                <ConnectedPro
                    class="rounded-lg flex-row border-gray-300 dark:border-gray-700 border-solid border-2 pt-2"
                    v-for="(member, i) in members"
                    v-on="updatePros"
                    :pro="member"
                    :key="member.id"
                    :user="user"
                    :show-featured="false"
                    v-on:openPingModal="openPingModal"
                    v-on:openShareModal="openShareModal"
                />
            </div>
            <div
                v-if="isLoading"
                style="border-top-color: transparent"
                class="w-8 h-8 border-4 mx-auto my-5 border-blue-400 border-solid rounded-full animate-spin"
            ></div>
        </div>
    </div>
</template>

<script>
import ConnectedPro from '../../Dashboard/partials/ConnectedPro.vue';
export default {
    data() {
        return {
            selectedIndustry: "",
            selectedProfession: "",
            members: [],

            sortBy: "Alpha",
            paginationData: null,
            data: null,
            isLoading: false,
            isSearching: false,
            search_location: (this.user && this.user.home_location
                && this.user.home_location.lat && this.user.home_location.lng) ? {
                'lat': this.user.home_location.lat,
                'lng': this.user.home_location.lng,
                'postal_code': this.user.home_location.postal_code
            } : ((this.user && this.user.home_location
                && this.user.business_location.lat && this.user.business_location.lng) ? {
                'lat': this.user.business_location.lat,
                'lng': this.user.business_location.lng,
                'postal_code': this.user.business_location.postal_code
            } : null),
            radiusChoices: ["All", "5mi", "10mi", "20mi", "50mi", "1000mi"],
            search_text: '',
            walkinsWelcome: false,
//            selectedRadius: "10mi",
            search_options: [],
        };
    },
    props: [ "user",
             "industries",
             "industry",
             "professions",
             "profession",
             "updatePros",
             "organization",
             "searchOptions",
             "withSubmit"],
    components: {
        ConnectedPro,
    },
    methods: {
        openPingModal(member) {
            this.$emit("openPingModal", member);
        },
        openShareModal( member){
            this.$emit( "openShareModal", member);
        },
        distanceSort( pros){
            const comparator = ( a, b) => {
                if( a.distance < b.distance) return -1;
                if( a.distance > b.distance) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        alphaSort( pros){
            const comparator = ( a, b) => {
                if( a.last_name < b.last_name) return -1;
                if( a.last_name > b.last_name) return 1;
                if( a.first_name < b.first_name) return -1;
                if( a.first_name > b.first_name) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        careScoreSort( pros){
            const comparator = ( a, b) => {
                if( a.care_score > b.care_score) return -1;
                if( a.care_score < b.care_score) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        async applyFilters( filters, update){
            console.log( "applyFilters");
            console.log( filters);
            const params = new URLSearchParams();
            if( filters !== null) {
                console.log( 'have filters');
                if( filters.search_text) params.append( 'search_text', filters.search_text);
                if (filters.postal_code) {
                    console.log( 'sort distance postal_code ' + filters.postal_code + ' radius ' + filters.selectedRadius);
//                    params.append('sort', 'distance');
                    params.append('postal_code', filters.postal_code)
                    if( "All" === filters.selectedRadius
                        || "" === filters.selectedRadius)
                        params.append( 'radius', '8000mi');
                    else
                        params.append('radius', filters.selectedRadius);
                }
                console.log( 'sort ' + filters.sortBy);
                params.append('sort', filters.sortBy);

                if (filters.selectedIndustry) {
                    console.log('industry ' + filters.selectedIndustry);
                    params.append('industry', filters.selectedIndustry);
                }
                if (filters.selectedProfession) {
                    console.log('profession ' + filters.selectedProfession);
                    params.append('profession', filters.selectedProfession);
                }
                if( filters.walkinsWelcome) {
                    console.log( 'walkins welcome ' + filters.walkinsWelcome);
                    params.append( 'walkins_welcome', filters.walkinsWelcome);
                }
            }
//            console.log( 'params');

            axios.post( `/organizations/${this.organization.id}/memberFeed`, null,{ params })
                  .then( (response) => {
                      this.members = response.data; // get from reloaded feed
                      console.log( this.members);
                      if( update)
                          this.$emit( 'updatePros');
                    })
                  .catch(error =>{
                       console.log(error);
                  });
        },
        sortPros( sortBy){
            console.log( 'sort pros by ');
            console.log( sortBy);
            this.sortOrder = sortBy;
            switch( sortBy){
                case "Distance": this.members = this.distanceSort( this.members);
                    break;
                case "Alpha": this.members = this.alphaSort( this.members);
                    break;
                case "CareScore": this.members = this.careScoreSort( this.members);
                    break;
            }
            this.$emit( 'updatePros');
            return 0;
        },
    },
    mounted(){
        console.log( "filtered professions: " );
        console.log( this.professions);

        this.applyFilters({
            search_text: "",
            selectedIndustry: "",
            selectedProfession: "",
            selectedRadius: "",
            walkinsWelcome: false,
            sortBy: "Alpha",
            postal_code: (this.user && this.user.home_location && this.user.home_location.postal_code)
                ? this.user.home_location.postal_code
                : ((this.user && this.user.business_location)
                    ? this.user.business_location.postal_code
                    : "")
            },
            false
        ).then( sort => this.sortPros( 'Alpha'));
    },
};
</script>
